var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "Topic-title" }, [_vm._v("基础通信 Topic 列表")]),
    _c(
      "div",
      [
        _c(
          "vxe-table",
          {
            attrs: {
              "row-id": "id",
              data: _vm.table,
              "sort-config": {
                defaultSort: { field: "topic_use", order: "asc" },
              },
              align: "left",
            },
          },
          [
            _c("vxe-table-column", {
              attrs: {
                sortable: "",
                field: "topic_use",
                "show-overflow": "",
                "min-width": "50",
                title: "功能",
              },
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "topic",
                "show-overflow": "",
                "min-width": "420",
                title: "Topic",
              },
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "topic_power",
                "show-overflow": "",
                "min-width": "80",
                title: "操作权限",
              },
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "topic_desc",
                "show-overflow": "",
                "min-width": "220",
                title: "描述",
              },
            }),
            _c("vxe-column", {
              attrs: { title: "操作", "min-width": "140" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (slotProps) {
                    return [
                      _c(
                        "span",
                        { staticClass: "handle-button" },
                        [
                          _c(
                            "v-button",
                            {
                              attrs: {
                                slot: "reference",
                                size: "S",
                                type: "text",
                                name: "btn1",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openViewModel(slotProps.row, 2)
                                },
                              },
                              slot: "reference",
                            },
                            [_vm._v(" 查看 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("UpdataAndview", {
          ref: "UpdataAndview",
          attrs: {
            showInputDialog: _vm.UpdataAndviewloading,
            id: _vm.id,
            category: _vm.category,
          },
          on: {
            "update:showInputDialog": function ($event) {
              _vm.UpdataAndviewloading = $event
            },
            "update:show-input-dialog": function ($event) {
              _vm.UpdataAndviewloading = $event
            },
            getData: _vm.getData,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }